import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const AboutDialog = ({ open, setOpen }) => {
  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>About Us</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Big Oven Tees is a print-on-demand app that connects directly with
          your Shopify, WooCommerce and other platform stores. This allows you
          to create an entire catalog of products without spending tons of money
          on inventory. Big Oven Tees partners with fulfillment companies who
          customize all its offered products for your online stores and ships
          them finished directly to your customers anywhere in the world.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AboutDialog;
